module.exports = __webpack_public_path__ + "d0c7fec54a2ed4d267232b3c02869940.png";